"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordLoginRequest = void 0;
var ResetPasswordLoginRequest = /** @class */ (function () {
    function ResetPasswordLoginRequest() {
    }
    return ResetPasswordLoginRequest;
}());
exports.ResetPasswordLoginRequest = ResetPasswordLoginRequest;
;
//# sourceMappingURL=resetPasswordLogin.request.js.map